import siteApiV4 from "src/api/clients/site-api-v4";
import { SiteAdmin } from "src/features/site-management/types/responses/site-admin";
import { UserRole } from "src/types/enum/user-role";
import { PaginatedData } from "src/types/responses/paginated-data";
import { SiteAdminProfile } from "../../types/responses/site-admin-profile";

class SiteAdminsApi {
  async fetchSiteAdmins(page: number, perPage: number): Promise<PaginatedData<SiteAdmin>> {
    const { data } = await siteApiV4.get<PaginatedData<SiteAdmin>>("/admins", {
      params: {
        page,
        perPage,
      },
    });

    return data;
  }

  async fetchSiteAdmin(siteAdminToken: string): Promise<SiteAdmin> {
    const { data } = await siteApiV4.get<SiteAdmin>(`/admins/${siteAdminToken}`);

    return data;
  }

  async createSiteAdmin(email: string, role: UserRole, phoneNumber: string): Promise<SiteAdmin> {
    const { data } = await siteApiV4.post<SiteAdmin>("/admins", {
      email,
      role,
      phoneNumber,
    });

    return data;
  }

  async updateSiteAdminPhoneNumber(siteAdminToken: string, phoneNumber: string): Promise<SiteAdmin> {
    const { data } = await siteApiV4.patch<SiteAdmin>(`/admins/${siteAdminToken}`, {
      phoneNumber,
    });

    return data;
  }

  async updateSiteAdminRole(siteAdminToken: string, role: UserRole): Promise<SiteAdmin> {
    const { data } = await siteApiV4.patch<SiteAdmin>(`/admins/${siteAdminToken}/role`, {
      role,
    });

    return data;
  }

  async removeSiteAdmin(siteAdminToken: string): Promise<void> {
    await siteApiV4.delete<SiteAdmin>(`/admins/${siteAdminToken}`);
  }

  async fetchSiteAdminsProfile(): Promise<SiteAdminProfile> {
    const { data } = await siteApiV4.get<SiteAdminProfile>(`/admins/profile`);

    return data;
  }

  async resendSiteAdminInvitation(siteAdminToken: string): Promise<void> {
    await siteApiV4.post(`/admins/${siteAdminToken}/resend-invitation`);
  }
}

export const siteAdminsApi = new SiteAdminsApi();
